// ============================================
// CE QUE CHAQUE RÔLE VOIT DANS LES COMPTEURS
// ============================================
// Liste des dossiers (GET /admin/tickets) : depuis l'arbitrage du ticket
// GitLab #50, tout le personnel, agent compris, reçoit aussi les dossiers
// qui n'ont pas encore de conseiller (un filtre explicite de conseiller
// reste appliqué).
// Statistiques (GET /admin/tickets/stats) : inchangées, globales pour
// l'encadrement, limitées aux dossiers de l'agent pour un agent. Les dossiers
// sans conseiller sont lus à part (chargerNonAssignes) : pour un agent, on
// les ajoute au badge qui renvoie vers la liste, sinon il annoncerait 0
// dossier ouvert alors que la liste en montre.

import { TicketStatus, type TicketStats, type UserRole } from '../../types';

/** Administrateur ou superviseur : statistiques globales. */
export const estEncadrement = (role: UserRole | string | undefined): boolean =>
  role === 'ADMIN' || role === 'SUPERVISOR';

/**
 * Badge « dossiers ouverts » de la barre latérale : nouveaux et réouverts.
 * Pour un agent, ses dossiers d'après les statistiques, plus les dossiers
 * sans conseiller (tous nouveaux ou réouverts par construction). Les dossiers
 * ouverts d'un collègue n'y sont pas : les statistiques d'un agent ne les
 * donnent pas.
 */
export function compteDossiersOuverts(
  stats: Pick<TicketStats, 'byStatus'> | null | undefined,
  nombreNonAssignes: number,
  role: UserRole | string | undefined,
): number {
  const siens = (stats?.byStatus?.[TicketStatus.OPEN] || 0) + (stats?.byStatus?.[TicketStatus.REOPENED] || 0);
  return estEncadrement(role) ? siens : siens + Math.max(0, nombreNonAssignes);
}
